<ui-section [subtitle]="subtitle()">
    <ui-section-content>
        <div class="grid-container grid-2 gap-5">
            @for (button of input().buttons; track button) {
                <div
                    class="text-body-bold bg-light-faded bg-light-highlight-hover rounded cursor-hand text button"
                    (click)="submit(button.code)"
                >
                    <div>
                        @if (button.iconName; as iconName) {
                            <ui-icon size="small" [name]="iconName" />
                        }
                        <span class="center">{{ button.text }}</span>
                    </div>
                </div>
            }
        </div>
    </ui-section-content>
</ui-section>
